import { useState, useEffect, useMemo } from "react";
import moment from "moment";
import Select from "react-select";
import Calendar from "../../../components/calendar";
import { ESTILO_BOTON_LISTAR_NUEVO } from "../../../utils/const/estilos-const";
import "../../../style/style-cargando.css";
import cargandoCard from "../../../components/cargando-card";
import sinAccesoCard from "../../../components/sin-acceso-card";
import { useTranslation } from "react-i18next";
import { obtenerListaSolicitudProductoAprobado } from "../../../api/api-solicitud-producto";
import { STRING_ID_TIPO_USUARIO_WEB, STRING_SUPER_ADMIN, STRING_ID_ROL_USUARIO_WEB, STRING_ID_USUARIO_WEB } from "../../../utils/const/string-const";
import { obtenerPermisoRolUsuarioWeb } from "../../../api/api-permiso-rol-usuario-web";
import { PAGE_ID } from "../../usuarios/gestionar-rol-usuario-web/pages-const";
import { useToast, useProcessing } from "../../../context/ui-feedback-context";
import { obtenerListaKanban } from "../../../api/api-kanban";
import ProgramacionSolicitudProductoKanbanCard from "../../../components/programacion-solicitud-producto-kanban-card";
import ModalConfigAccionesProgramacionKanban from "../../../components/modal-config-acciones-programacion-kanban";
import {
  actualizarWorkflowProgramacionSolicitudProducto,
  crearConfigProgramacionKanbanDefault,
  crearWorkflowProgramacionSolicitudProducto,
  normalizarConfigProgramacionKanban,
  obtenerListaWorkflowProgramacionSolicitudProducto,
} from "../../../api/api-workflow-programacion-solicitud-producto";
import {
  actualizarStatusKanban,
  guardarStatusKanban,
  obtenerStatusKanban,
} from "../../../api/api-status-kanban";
import { obtenerListaPersona } from "../../../api/api-persona";
import { obtenerListaAccionesKanbanUsuario } from "../../../api/api-acciones-kanban-usuario";
import { obtenerGeocercas } from "../../../api/api-grupo-geocerca";
import { obtenerGeoruta } from "../../../api/api-viaje";
import { Settings } from "lucide-react";
import { TIPO_INPUT } from "../../viaje/tipo_input";
import ModalSeleccionarPersonasAlerta from "../../../components/modal-seleccionar-personas-alerta";
import {
  crearAlertasIniciarViaje,
  deshabilitarAlertasIniciarViaje,
  extraerDatosCardProductos,
} from "./helpers-alertas-iniciar-viaje";

const ID_TABLERO = 'producto';

const formatearValorMeta = (value) => {
  if (value == null || value === "") return null;
  if (typeof value === "object") {
    if (typeof value.label === "string" && value.label.trim().length > 0) {
      return value.label;
    }
    try {
      return JSON.stringify(value);
    } catch {
      return String(value);
    }
  }
  return String(value);
};

const parseMetaFromItem = (item) => {
  if (Array.isArray(item?.meta)) return item.meta;
  if (typeof item?.meta === "string" && item.meta.trim().length > 0) {
    try {
      const parsed = JSON.parse(item.meta);
      return Array.isArray(parsed) ? parsed : [];
    } catch (err) {
      return [];
    }
  }
  return [];
};

const SEMANTIC_META_LABEL_KEYS = {
  [TIPO_INPUT.GEOCERCA_ORIGEN]: "label_geocerca_origen",
  [TIPO_INPUT.GEOCERCA_DESTINO]: "label_geocerca_destino",
  [TIPO_INPUT.GEORUTA]: "label_georuta",
  [TIPO_INPUT.FECHA_SALIDA]: "label_fecha_salida",
  [TIPO_INPUT.FECHA_LLEGADA]: "label_fecha_llegada",
  [TIPO_INPUT.HORA_SALIDA]: "label_hora_salida",
  [TIPO_INPUT.HORA_LLEGADA]: "label_hora_llegada",
  [TIPO_INPUT.SELECCIONE_VEHICULO]: "label_seleccione_vehiculo",
};

const getMetaLabel = (campo, t) => {
  const key = SEMANTIC_META_LABEL_KEYS[campo?.type];
  if (key) return t(key);
  return campo?.label ?? campo?.type ?? "—";
};

const REQUIRED_META_TYPES_INICIAR_VIAJE = [
  TIPO_INPUT.GEOCERCA_ORIGEN,
  TIPO_INPUT.GEOCERCA_DESTINO,
  TIPO_INPUT.FECHA_SALIDA,
  TIPO_INPUT.FECHA_LLEGADA,
  TIPO_INPUT.HORA_SALIDA,
  TIPO_INPUT.HORA_LLEGADA,
  TIPO_INPUT.SELECCIONE_VEHICULO,
];

const obtenerTiposFaltantesIniciarViaje = (item) => {
  const meta = parseMetaFromItem(item);
  const tiposPresentes = new Set(
    meta.map((m) => m?.type).filter((t) => typeof t === "string")
  );
  return REQUIRED_META_TYPES_INICIAR_VIAJE.filter((tipo) => !tiposPresentes.has(tipo));
};

const esColumnaIniciaViaje = (column) => {
  const flag = column?.esteEstadoIniciaViaje;
  return flag === true || flag === 1 || flag === "1";
};

const FILTRO_FECHA_TIPOS = {
  TODAS: "todas",
  HOY: "hoy",
  AYER: "ayer",
  RANGO: "rango",
};

const filtrarItemsColumna = (items, tipo, fechaInicio, fechaFin) => {
  const arr = Array.isArray(items) ? items : [];
  if (!tipo || tipo === FILTRO_FECHA_TIPOS.TODAS) return arr;

  let inicio;
  let fin;
  if (tipo === FILTRO_FECHA_TIPOS.HOY) {
    inicio = moment().startOf("day");
    fin = moment().endOf("day");
  } else if (tipo === FILTRO_FECHA_TIPOS.AYER) {
    inicio = moment().subtract(1, "day").startOf("day");
    fin = moment().subtract(1, "day").endOf("day");
  } else if (tipo === FILTRO_FECHA_TIPOS.RANGO) {
    inicio = moment(fechaInicio, "YYYY-MM-DD").startOf("day");
    fin = moment(fechaFin, "YYYY-MM-DD").endOf("day");
    if (!inicio.isValid() || !fin.isValid()) return arr;
  } else {
    return arr;
  }

  return arr.filter((item) => {
    const fecha = moment(item?.fechaProceso);
    return fecha.isValid() && fecha.isBetween(inicio, fin, null, "[]");
  });
};

const buildAccionesConfigByColumn = (kanbanLista, configLista) => {
  const nextConfig = {};
  const configsByKanban = {};

  (Array.isArray(configLista) ? configLista : []).forEach((config) => {
    if (!config?.idKanban) return;
    if (String(config.idKanban).includes("__")) return;
    configsByKanban[config.idKanban] = config;
  });

  (Array.isArray(kanbanLista) ? kanbanLista : []).forEach((column) => {
    const saved = configsByKanban[column.id];
    nextConfig[column.id] = normalizarConfigProgramacionKanban(
      saved ??
      crearConfigProgramacionKanbanDefault({
        idKanban: column.id,
        acciones: column.acciones,
      }),
      column.acciones
    );
  });

  return nextConfig;
};

const getAccionConfigFromColumn = (columnConfig, idAccion) => {
  const acciones = Array.isArray(columnConfig?.acciones) ? columnConfig.acciones : [];
  return acciones.find((accion) => String(accion.idAccion) === String(idAccion)) ?? null;
};

const parseStatusChildren = (children) => {
  if (Array.isArray(children)) return children;
  if (typeof children === "string" && children.trim()) {
    try {
      const parsed = JSON.parse(children);
      return Array.isArray(parsed) ? parsed : [];
    } catch (err) {
      return [];
    }
  }
  return [];
};

const buildKanbanItemsFromStatus = (
  kanbanLista,
  productosLista,
  statusLista
) => {
  const itemsByColumn = (Array.isArray(kanbanLista) ? kanbanLista : []).reduce(
    (acc, column) => {
      acc[column.id] = [];
      return acc;
    },
    {}
  );
  const status = Array.isArray(statusLista) ? statusLista : [];
  const firstColumn = [...(Array.isArray(kanbanLista) ? kanbanLista : [])].sort(
    (a, b) => (a.orden ?? 0) - (b.orden ?? 0)
  )[0];

  const productosById = new Map(
    (Array.isArray(productosLista) ? productosLista : [])
      .filter((p) => p?.id != null)
      .map((p) => [String(p.id), p])
  );

  if (status.length > 0) {
    const placedCardIds = new Set();

    status.forEach((columnStatus) => {
      if (!Object.prototype.hasOwnProperty.call(itemsByColumn, columnStatus?.idKanban)) {
        return;
      }
      const savedChildren = parseStatusChildren(columnStatus.children);
      // Solo mantener los guardados que siguen apareciendo en el endpoint;
      // usar la versión fresca del endpoint (datos actualizados) pero preservar
      // los IDs de alertas persistidas al entrar a "Iniciar viaje".
      const filtered = savedChildren
        .filter((item) => item?.id != null && productosById.has(String(item.id)))
        .map((savedItem) => {
          const fresh = productosById.get(String(savedItem.id));
          if (savedItem?.alertasIniciarViaje) {
            return { ...fresh, alertasIniciarViaje: savedItem.alertasIniciarViaje };
          }
          return fresh;
        });
      filtered.forEach((item) => placedCardIds.add(String(item.id)));
      itemsByColumn[columnStatus.idKanban] = filtered;
    });

    if (firstColumn) {
      const newItems = (Array.isArray(productosLista) ? productosLista : []).filter(
        (item) => item?.id != null && !placedCardIds.has(String(item.id))
      );
      itemsByColumn[firstColumn.id] = [
        ...(itemsByColumn[firstColumn.id] ?? []),
        ...newItems,
      ];
    }

    return itemsByColumn;
  }

  if (firstColumn) {
    itemsByColumn[firstColumn.id] = Array.isArray(productosLista) ? productosLista : [];
  }
  return itemsByColumn;
};

export default function ListarProgramacionProductosKanbanPage
  () {
  const idTipoUsuarioWeb = localStorage.getItem(STRING_ID_TIPO_USUARIO_WEB);
  const { t } = useTranslation();
  const [cargandoPage, setCargandoPage] = useState(true);
  const [tieneAccesoAlModulo, setTieneAccesoAlModulo] = useState(false);
  const [habilitadoSelected, setHabilitadoSelected] = useState(null);

  const [btnBuscar, setBtnBuscar] = useState(false);

  const { showToast } = useToast();
  const { showProcessing, hideProcessing } = useProcessing();

  const [listaKanban, setListaKanban] = useState([]);
  const [listaProductos, setListaProductos] = useState([]);
  const [kanbanItemsByColumn, setKanbanItemsByColumn] = useState({});
  const [statusKanbanId, setStatusKanbanId] = useState(null);
  const [accionesConfigByColumn, setAccionesConfigByColumn] = useState({});
  const [modalConfigVisible, setModalConfigVisible] = useState(false);
  const [columnConfigSelected, setColumnConfigSelected] = useState(null);
  const [modalDetalleVisible, setModalDetalleVisible] = useState(false);
  const [itemDetalleSelected, setItemDetalleSelected] = useState(null);
  const [modalDatosFaltantesVisible, setModalDatosFaltantesVisible] = useState(false);
  const [datosFaltantes, setDatosFaltantes] = useState([]);

  const [listaPersonas, setListaPersonas] = useState([]);
  const [listaGeocercas, setListaGeocercas] = useState([]);
  const [listaGeorutas, setListaGeorutas] = useState([]);
  const [modalPersonasAlertaVisible, setModalPersonasAlertaVisible] = useState(false);
  const [movimientoAlertaPendiente, setMovimientoAlertaPendiente] = useState(null);

  const filtroFechaOpciones = useMemo(() => [
    { value: FILTRO_FECHA_TIPOS.TODAS, label: t("label_filtro_todas") || "Todas" },
    { value: FILTRO_FECHA_TIPOS.HOY, label: t("label_filtro_hoy") || "Hoy" },
    { value: FILTRO_FECHA_TIPOS.AYER, label: t("label_filtro_ayer") || "Ayer" },
    { value: FILTRO_FECHA_TIPOS.RANGO, label: t("label_filtro_rango") || "Rango personalizado" },
  ], [t]);
  // Map<columnId, { tipo, tipoOption, fechaInicio, fechaFin }>
  const [filtrosPorColumna, setFiltrosPorColumna] = useState({});

  const getFiltroColumna = (colId) => {
    const filtro = filtrosPorColumna[colId];
    if (filtro) return filtro;
    return {
      tipo: FILTRO_FECHA_TIPOS.TODAS,
      tipoOption: filtroFechaOpciones[0],
      fechaInicio: moment().startOf("week").format("YYYY-MM-DD"),
      fechaFin: moment().endOf("week").format("YYYY-MM-DD"),
    };
  };

  const updateFiltroColumna = (colId, patch) => {
    setFiltrosPorColumna((prev) => ({
      ...prev,
      [colId]: { ...getFiltroColumna(colId), ...patch },
    }));
  };
  const currentUserId = localStorage.getItem(STRING_ID_USUARIO_WEB);
  // Map<idAccionKanban, Set<idUsuario>> — vacío = pública (todos permitidos)
  const [accionesPermitidasMap, setAccionesPermitidasMap] = useState({});

  useEffect(() => {
    iniciar();
  }, []);

  // vacío/undefined en el map = pública (permite a todos, backwards-compat)
  // super admin bypasa siempre el filtro
  const filterAccionesByUsuario = (acciones) => {
    const arr = Array.isArray(acciones) ? acciones : [];
    if (idTipoUsuarioWeb === STRING_SUPER_ADMIN) return arr;
    return arr.filter((accion) => {
      const permitidos = accionesPermitidasMap[accion.id];
      if (!permitidos || permitidos.size === 0) return true;
      return permitidos.has(currentUserId);
    });
  };

  const iniciar = async () => {
    let tieneAcceso = false;
    try {
      let objEnviar = {};
      objEnviar.habilitado = habilitadoSelected !== null ? habilitadoSelected.value : null;
      objEnviar.idTablero = ID_TABLERO;
      if (idTipoUsuarioWeb === STRING_SUPER_ADMIN) {
        tieneAcceso = true;
        setBtnBuscar(true);
      }
      if (idTipoUsuarioWeb !== STRING_SUPER_ADMIN) {
        const idRolUsuarioWeb = localStorage.getItem(STRING_ID_ROL_USUARIO_WEB);
        objEnviar.idRolUsuarioWeb = idRolUsuarioWeb;
        const response = await obtenerPermisoRolUsuarioWeb(objEnviar);
        if (response.error === false && response.data !== undefined) {
          const permisos = JSON.parse(response.data.permisos);
          if (Array.isArray(permisos) && permisos.length > 0) {
            const manage = permisos.find(p => p.id === 8);
            if (manage !== undefined && manage !== null) {
              const permisosPage = manage.subMenu.find(p => p.value === PAGE_ID.GESTIONAR_PROGRAMACION_PRODUCTOS_KANBAN);
              tieneAcceso = permisosPage.checked;
              if (tieneAcceso === false) {
                return;
              }
              const permisoBtnBuscar = permisosPage.acciones.find(a => a.value === 'btn_buscar');
              setBtnBuscar(permisoBtnBuscar?.checked);
            }
          }
        }
      }
      if (tieneAcceso === true) {
        const [productos, kanban, personas, responseConfig, responseGeocercas, responseGeorutas] =
          await Promise.all([
            obtenerListaSolicitudProductoAprobado(objEnviar, false, t),
            obtenerListaKanban(objEnviar, false, t),
            obtenerListaPersona({ habilitado: 1 }, true),
            obtenerListaWorkflowProgramacionSolicitudProducto(),
            obtenerGeocercas(),
            obtenerGeoruta(),
          ]);
        setListaGeocercas(
          responseGeocercas?.error === false && Array.isArray(responseGeocercas.body)
            ? responseGeocercas.body
            : []
        );
        setListaGeorutas(
          responseGeorutas?.error === false && Array.isArray(responseGeorutas.body)
            ? responseGeorutas.body
            : []
        );
        const responseStatus = await obtenerStatusKanban({ idTablero: ID_TABLERO });
        const productosLista = Array.isArray(productos) ? productos : [];
        const kanbanLista = Array.isArray(kanban) ? kanban : [];
        setListaProductos(productosLista);
        setListaKanban(kanbanLista);
        setStatusKanbanId(responseStatus?.id ?? null);
        setKanbanItemsByColumn(
          buildKanbanItemsFromStatus(
            kanbanLista,
            productosLista,
            responseStatus?.error === false ? responseStatus.data : []
          )
        );

        setAccionesConfigByColumn(
          buildAccionesConfigByColumn(kanbanLista, responseConfig?.data ?? [])
        );

        setListaPersonas(Array.isArray(personas) ? personas : []);

        // Cargar usuarios permitidos por cada acción de cada columna
        const uniqueAccionIds = new Set();
        kanbanLista.forEach((col) => {
          (Array.isArray(col.acciones) ? col.acciones : []).forEach((a) => {
            if (a?.id != null) uniqueAccionIds.add(a.id);
          });
        });
        const accionIds = [...uniqueAccionIds];
        const permitidosResults = await Promise.all(
          accionIds.map((idAccionKanban) =>
            obtenerListaAccionesKanbanUsuario({ idAccionKanban })
          )
        );
        const nextMap = {};
        accionIds.forEach((idAccionKanban, idx) => {
          const rows = permitidosResults[idx] ?? [];
          nextMap[idAccionKanban] = new Set(
            (Array.isArray(rows) ? rows : []).map((r) => r.idUsuario)
          );
        });
        setAccionesPermitidasMap(nextMap);
      }
    } catch (err) {
      console.log('iniciar err');
      console.log(err);
    } finally {
      setCargandoPage(false);
      setTieneAccesoAlModulo(tieneAcceso);
    }
  };

  const reset = async () => {
    setCargandoPage(true);
    iniciar();
  };

  const aplicarMovimiento = (sourceColumnId, targetColumnId, itemActualizado) => {
    const sourceItems = kanbanItemsByColumn[sourceColumnId] ?? [];
    const next = { ...kanbanItemsByColumn };
    next[sourceColumnId] = sourceItems.filter(
      (card) => String(card.id) !== String(itemActualizado.id)
    );
    const targetItems = next[targetColumnId] ?? [];
    if (!targetItems.some((card) => String(card.id) === String(itemActualizado.id))) {
      next[targetColumnId] = [...targetItems, itemActualizado];
    } else {
      next[targetColumnId] = targetItems.map((card) =>
        String(card.id) === String(itemActualizado.id) ? itemActualizado : card
      );
    }
    setKanbanItemsByColumn(next);
    guardarEstadoKanban(next);
    return next;
  };

  const ejecutarMovimientoConAlertas = async (destinos) => {
    const pendiente = movimientoAlertaPendiente;
    if (!pendiente) return;
    const { sourceColumnId, targetColumnId, movingItem, accionConfig } = pendiente;
    showProcessing();
    try {
      const cardData = extraerDatosCardProductos(movingItem);
      const { success, alertasIniciarViaje, errores, erroresRollback } =
        await crearAlertasIniciarViaje({
          cardData,
          listaGeocercas,
          listaGeorutas,
          destinos,
        });
      if (!success) {
        const detalle = errores.map((e) => `${e.key}: ${e.message ?? "error"}`).join("; ");
        const msgBase = t("alert_no_se_pudieron_crear_alertas") || "No se pudieron crear todas las alertas. Movimiento cancelado.";
        showToast(detalle ? `${msgBase} — ${detalle}` : msgBase, "error", 4500);
        if (erroresRollback?.length > 0) {
          const ids = erroresRollback.map((e) => `${e.key}(${e.id})`).join(", ");
          showToast(
            (t("alert_rollback_alertas_parcial") || "Rollback parcial, alertas huérfanas") + `: ${ids}`,
            "warning",
            5000
          );
        }
        return;
      }
      const itemActualizado = { ...movingItem, alertasIniciarViaje };
      aplicarMovimiento(sourceColumnId, targetColumnId, itemActualizado);
      showToast(
        accionConfig?.mensaje || t("alert_card_movida_kanban"),
        "success",
        3000
      );
    } finally {
      hideProcessing();
      setMovimientoAlertaPendiente(null);
      setModalPersonasAlertaVisible(false);
    }
  };

  const handleAccionKanban = async (accion, item, column) => {
    const columnConfig = accionesConfigByColumn[column.id] ?? null;
    const accionConfig = getAccionConfigFromColumn(columnConfig, accion.id);
    const targetColumnId = accionConfig?.moverAKanban?.value ?? null;

    if (!targetColumnId) {
      showToast(t("alert_configure_acciones_programacion_kanban"), "warning", 3500);
      setColumnConfigSelected(column);
      setModalConfigVisible(true);
      return;
    }

    const sourceItems = kanbanItemsByColumn[column.id] ?? [];
    const movingItem = sourceItems.find((card) => String(card.id) === String(item.id));
    if (!movingItem) return;

    const targetColumn = (Array.isArray(listaKanban) ? listaKanban : []).find(
      (c) => String(c.id) === String(targetColumnId)
    );
    const sourceEsIniciarViaje = esColumnaIniciaViaje(column);
    const targetEsIniciarViaje = esColumnaIniciaViaje(targetColumn);

    if (targetEsIniciarViaje) {
      const faltantes = obtenerTiposFaltantesIniciarViaje(movingItem);
      if (faltantes.length > 0) {
        setDatosFaltantes(faltantes);
        setModalDatosFaltantesVisible(true);
        return;
      }
      setMovimientoAlertaPendiente({
        sourceColumnId: column.id,
        targetColumnId,
        movingItem,
        accionConfig,
      });
      setModalPersonasAlertaVisible(true);
      return;
    }

    if (sourceEsIniciarViaje && movingItem.alertasIniciarViaje) {
      showProcessing();
      let resultado;
      try {
        resultado = await deshabilitarAlertasIniciarViaje(movingItem.alertasIniciarViaje);
      } finally {
        hideProcessing();
      }
      if (!resultado.success) {
        const detalle = resultado.errores
          .map((e) => `${e.key}: ${e.message ?? "error"}`)
          .join("; ");
        const msgBase = t("alert_no_se_pudieron_deshabilitar_alertas") ||
          "No se pudieron deshabilitar todas las alertas. Movimiento cancelado.";
        showToast(detalle ? `${msgBase} — ${detalle}` : msgBase, "error", 4500);
        // Persistir en el item solo los IDs que siguen activos para reintentar luego.
        const itemConParciales = {
          ...movingItem,
          alertasIniciarViaje: resultado.alertasRestantes,
        };
        aplicarMovimiento(column.id, column.id, itemConParciales);
        return;
      }
      const itemSinAlertas = { ...movingItem };
      delete itemSinAlertas.alertasIniciarViaje;
      aplicarMovimiento(column.id, targetColumnId, itemSinAlertas);
      showToast(
        accionConfig?.mensaje || t("alert_card_movida_kanban"),
        "success",
        3000
      );
      return;
    }

    aplicarMovimiento(column.id, targetColumnId, movingItem);
    showToast(
      accionConfig?.mensaje || t("alert_card_movida_kanban"),
      "success",
      3000
    );
  };

  const handleOpenConfigColumn = (column) => {
    setColumnConfigSelected(column);
    setModalConfigVisible(true);
  };

  const handleSaveConfigColumn = async (config) => {
    if (!columnConfigSelected?.id) return;

    const payload = {
      ...config,
      idKanban: columnConfigSelected.id,
      id: accionesConfigByColumn[columnConfigSelected.id]?.id ?? config.id ?? null,
    };
    const accionesMeta = columnConfigSelected.acciones ?? [];

    showProcessing();
    const response = payload.id
      ? await actualizarWorkflowProgramacionSolicitudProducto(payload, accionesMeta)
      : await crearWorkflowProgramacionSolicitudProducto(payload, accionesMeta);
    hideProcessing();

    if (response.error === true) {
      showToast(response.message || t("alert_no_se_pudo_crear"), "error", 3000);
      return;
    }

    setAccionesConfigByColumn((prev) => ({
      ...prev,
      [columnConfigSelected.id]: response.data,
    }));

    setModalConfigVisible(false);
    setColumnConfigSelected(null);
    showToast(t("label_guardar"), "success", 2000);
  };

  const listaKanbanOrdenada = [...(Array.isArray(listaKanban) ? listaKanban : [])].sort(
    (a, b) => (a.orden ?? 0) - (b.orden ?? 0)
  );

  const guardarEstadoKanban = async (itemsByColumn) => {
    const estadoKanban = listaKanbanOrdenada.map((kanban) => ({
      idKanban: kanban.id,
      descripcion: kanban.descripcion,
      orden: kanban.orden,
      children: [...(itemsByColumn[kanban.id] ?? [])],
    }));

    showProcessing();
    const response = statusKanbanId
      ? await actualizarStatusKanban(statusKanbanId, estadoKanban, ID_TABLERO)
      : await guardarStatusKanban(estadoKanban, ID_TABLERO);
    hideProcessing();

    if (response.error === true) {
      showToast(response.message || t("alert_no_se_pudo_crear"), "error", 3000);
      return;
    }

    if (!statusKanbanId && response.id) {
      setStatusKanbanId(response.id);
    }
  };

  const render = () => {
    try {
      if (cargandoPage === true) {
        return cargandoCard();
      }
      if (tieneAccesoAlModulo === false) {
        return sinAccesoCard();
      }
      return (
        <div className="w-full px-4 lg:px-6">
          <div className="flex items-center justify-between py-4">
            <div>
              <div className="flex items-center gap-2">
                <h2 className="text-xl font-bold text-gray-900">{t("label_gestionar_programacion_productos_kanban")}</h2>
              </div>
              <p className="text-sm text-gray-500">{t("label_administra_la_lista_de_programacion_productos_kanban")}</p>
            </div>
            {btnBuscar && (
              <div className="flex items-center gap-2">
                <button
                  type="button"
                  className={ESTILO_BOTON_LISTAR_NUEVO}
                  onClick={() => {
                    reset();
                  }}
                >
                  {t("label_actualizar")}
                </button>
              </div>
            )}
          </div>
          <hr />

          <div className="flex gap-4 overflow-x-auto items-start py-4 pb-6">
            {listaKanbanOrdenada.map((column) => {
              const filtro = getFiltroColumna(column.id);
              const allItems = kanbanItemsByColumn[column.id] ?? [];
              const columnItems = filtrarItemsColumna(
                allItems,
                filtro.tipo,
                filtro.fechaInicio,
                filtro.fechaFin
              );
              const filtroActivo = filtro.tipo !== FILTRO_FECHA_TIPOS.TODAS;
              return (
                <div
                  key={column.id}
                  className="flex flex-col w-80 shrink-0 bg-gray-50 border border-gray-200 rounded-lg overflow-hidden"
                >
                  <div className="px-3 py-2.5 border-b border-gray-200 bg-white">
                    <div className="flex items-center justify-between gap-2">
                      <h3 className="text-sm font-semibold text-gray-900 truncate">
                        {column.descripcion ?? "—"}
                      </h3>
                      <div className="flex items-center gap-2">
                        <button
                          type="button"
                          onClick={() => handleOpenConfigColumn(column)}
                          className="p-1 rounded text-gray-400 hover:text-gray-700 hover:bg-gray-100"
                          title={t("label_configurar_acciones_programacion_kanban")}
                        >
                          <Settings className="h-4 w-4" />
                        </button>
                        <span className="text-xs text-gray-500 bg-gray-100 px-2 py-0.5 rounded-full shrink-0">
                          {filtroActivo
                            ? `${columnItems.length}/${allItems.length}`
                            : columnItems.length}
                        </span>
                      </div>
                    </div>
                    <div className="mt-2 space-y-2">
                      <Select
                        options={filtroFechaOpciones}
                        value={filtro.tipoOption}
                        onChange={(option) =>
                          updateFiltroColumna(column.id, {
                            tipo: option?.value ?? FILTRO_FECHA_TIPOS.TODAS,
                            tipoOption: option ?? filtroFechaOpciones[0],
                          })
                        }
                        isSearchable={false}
                        isClearable={false}
                        menuPortalTarget={document.body}
                        styles={{
                          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                          control: (base) => ({ ...base, minHeight: 32, fontSize: 12 }),
                          singleValue: (base) => ({ ...base, fontSize: 12 }),
                        }}
                        placeholder={t("label_filtro_fecha") || "Filtro de fecha"}
                      />
                      {filtro.tipo === FILTRO_FECHA_TIPOS.RANGO && (
                        <div className="grid grid-cols-2 gap-2">
                          <Calendar
                            value={filtro.fechaInicio}
                            onChange={(date) =>
                              updateFiltroColumna(column.id, { fechaInicio: date })
                            }
                            placeholder={t("label_fecha_inicio")}
                            id={`filtro_fecha_inicio_${column.id}`}
                            name={`filtro_fecha_inicio_${column.id}`}
                          />
                          <Calendar
                            value={filtro.fechaFin}
                            onChange={(date) =>
                              updateFiltroColumna(column.id, { fechaFin: date })
                            }
                            placeholder={t("label_fecha_fin")}
                            id={`filtro_fecha_fin_${column.id}`}
                            name={`filtro_fecha_fin_${column.id}`}
                          />
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="flex-1 min-h-[280px] max-h-[calc(100vh-280px)] overflow-y-auto p-2 space-y-2">
                    {columnItems.length === 0 ? (
                      <div className="flex items-center justify-center h-24 text-xs text-gray-400 border border-dashed border-gray-200 rounded-lg">
                        {t("label_sin_datos")}
                      </div>
                    ) : (
                      columnItems.map((item) => (
                        <ProgramacionSolicitudProductoKanbanCard
                          key={item.id}
                          item={item}
                          acciones={filterAccionesByUsuario(column.acciones)}
                          onAccionClick={(accion, cardItem) =>
                            handleAccionKanban(accion, cardItem, column)
                          }
                          onClick={(cardItem) => {
                            setItemDetalleSelected(cardItem);
                            setModalDetalleVisible(true);
                          }}
                        />
                      ))
                    )}
                  </div>
                </div>
              );
            })}
          </div>

          <ModalConfigAccionesProgramacionKanban
            isOpen={modalConfigVisible}
            column={columnConfigSelected}
            listaKanban={listaKanbanOrdenada}
            listaPersonas={listaPersonas}
            initialConfig={
              columnConfigSelected
                ? accionesConfigByColumn[columnConfigSelected.id] ?? null
                : null
            }
            onCancel={() => {
              setModalConfigVisible(false);
              setColumnConfigSelected(null);
            }}
            onSave={handleSaveConfigColumn}
          />

          {modalDetalleVisible && itemDetalleSelected && (
            <div className="fixed z-50 top-0 left-0 right-0 bottom-0 flex items-center justify-center">
              <div
                className="fixed inset-0 bg-gray-500 opacity-75"
                onClick={() => {
                  setModalDetalleVisible(false);
                  setItemDetalleSelected(null);
                }}
              ></div>
              <div className="bg-white w-11/12 md:max-w-2xl mx-auto rounded shadow-lg z-50 overflow-hidden flex flex-col max-h-[85vh]">
                <div className="px-6 py-4 border-b border-gray-200">
                  <p className="text-lg font-semibold text-gray-900">
                    {itemDetalleSelected?.descripcion ?? t("label_solicitud")}
                  </p>
                  <div className="flex flex-wrap items-center gap-x-3 gap-y-1 mt-1">
                    {itemDetalleSelected?.fechaProceso ? (
                      <p className="text-xs text-gray-500">
                        {itemDetalleSelected.fechaProceso}
                      </p>
                    ) : null}
                    {itemDetalleSelected?.prioridad ? (
                      <p className="text-xs text-gray-500">
                        {t("label_prioridad")}: {itemDetalleSelected.prioridad}
                      </p>
                    ) : null}
                    {itemDetalleSelected?.codigo ? (
                      <p className="text-xs text-gray-500">
                        {itemDetalleSelected.codigo}
                      </p>
                    ) : null}
                  </div>
                </div>
                <div className="px-6 py-4 overflow-y-auto space-y-5">
                  {(() => {
                    const detalle = Array.isArray(itemDetalleSelected?.detalle)
                      ? itemDetalleSelected.detalle.filter(
                          (r) => r?.habilitado !== 0
                        )
                      : [];
                    const meta = parseMetaFromItem(itemDetalleSelected);
                    const nota = itemDetalleSelected?.nota;

                    if (detalle.length === 0 && meta.length === 0 && !nota) {
                      return (
                        <p className="text-sm text-gray-500">
                          {t("label_sin_datos")}
                        </p>
                      );
                    }
                    return (
                      <>
                        {detalle.length > 0 && (
                          <section>
                            <p className="text-xs font-semibold uppercase tracking-wide text-gray-500 mb-2">
                              {t("label_productos")}
                            </p>
                            <ul className="divide-y divide-gray-100">
                              {detalle.map((row, i) => (
                                <li
                                  key={row?.id ?? `detalle-${i}`}
                                  className="py-2 flex items-start justify-between gap-3"
                                >
                                  <span className="text-sm text-gray-800 min-w-0 break-words">
                                    {row?.producto ?? row?.idProducto ?? "—"}
                                  </span>
                                  <span className="text-sm font-semibold text-gray-800 shrink-0">
                                    {t("label_cantidad")}: {row?.cantidad ?? 0}
                                  </span>
                                </li>
                              ))}
                            </ul>
                          </section>
                        )}
                        {meta.length > 0 && (
                          <section>
                            <p className="text-xs font-semibold uppercase tracking-wide text-gray-500 mb-2">
                              {t("label_meta")}
                            </p>
                            <dl className="divide-y divide-gray-100">
                              {meta.map((m, i) => {
                                const valor = formatearValorMeta(m?.value);
                                return (
                                  <div
                                    key={m?.id ?? `meta-${i}`}
                                    className="py-2 grid grid-cols-1 md:grid-cols-3 gap-1 md:gap-3"
                                  >
                                    <dt className="text-xs font-semibold text-gray-500 md:col-span-1 break-words">
                                      {getMetaLabel(m, t)}
                                    </dt>
                                    <dd className="text-sm text-gray-800 md:col-span-2 break-words">
                                      {valor != null ? (
                                        valor
                                      ) : (
                                        <span className="text-gray-400 italic">
                                          {t("label_sin_respuesta")}
                                        </span>
                                      )}
                                    </dd>
                                  </div>
                                );
                              })}
                            </dl>
                          </section>
                        )}
                        {nota ? (
                          <section>
                            <p className="text-xs font-semibold uppercase tracking-wide text-gray-500 mb-2">
                              {t("label_nota")}
                            </p>
                            <p className="text-sm text-gray-800 break-words whitespace-pre-wrap">
                              {nota}
                            </p>
                          </section>
                        ) : null}
                      </>
                    );
                  })()}
                </div>
                <div className="px-6 py-3 border-t border-gray-200 flex justify-end">
                  <button
                    className="inline-flex justify-center px-4 py-2 text-sm font-medium text-white bg-blue-600 border border-transparent rounded-md hover:bg-blue-700 focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-blue-500"
                    onClick={() => {
                      setModalDetalleVisible(false);
                      setItemDetalleSelected(null);
                    }}
                  >
                    OK
                  </button>
                </div>
              </div>
            </div>
          )}

          <ModalSeleccionarPersonasAlerta
            isOpen={modalPersonasAlertaVisible}
            onCancel={() => {
              setModalPersonasAlertaVisible(false);
              setMovimientoAlertaPendiente(null);
            }}
            onConfirmar={(destinos) => ejecutarMovimientoConAlertas(destinos)}
            onSinDestinatario={(destinos) => ejecutarMovimientoConAlertas(destinos)}
          />

          {modalDatosFaltantesVisible && (
            <div className="fixed z-50 top-0 left-0 right-0 bottom-0 flex items-center justify-center">
              <div className="fixed inset-0 bg-gray-500 opacity-75"></div>
              <div className="bg-white w-11/12 md:max-w-md mx-auto rounded shadow-lg z-50 overflow-y-auto">
                <div className="py-4 text-left px-6">
                  <div className="mb-3">
                    <p className="text-lg font-semibold text-gray-900">
                      {t("label_datos_faltantes_iniciar_viaje")}
                    </p>
                  </div>
                  <div className="mb-4">
                    <p className="text-sm text-gray-700">
                      {t("label_faltan_datos_iniciar_viaje_desc")}
                    </p>
                    <ul className="mt-2 list-disc list-inside text-sm text-red-600">
                      {datosFaltantes.map((tipo) => (
                        <li key={tipo}>{t(SEMANTIC_META_LABEL_KEYS[tipo] ?? tipo)}</li>
                      ))}
                    </ul>
                  </div>
                  <div className="flex justify-end">
                    <button
                      className="inline-flex justify-center px-4 py-2 text-sm font-medium text-white bg-blue-600 border border-transparent rounded-md hover:bg-blue-700 focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-blue-500"
                      onClick={() => {
                        setModalDatosFaltantesVisible(false);
                        setDatosFaltantes([]);
                      }}
                    >
                      OK
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      );
    } catch (err) {
      console.log('ListarProgramacionProductosKanban render err');
      console.log(err);
      return (
        <div><label>{JSON.stringify(err)}</label></div>
      );
    }
  }

  return render();
}
